import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHighContrast } from 'client/store/mapSlice/mapSlice';

export const useDarkMode = () => {
    const query = window?.matchMedia?.('(prefers-color-scheme: dark)');
    const highContrast = useSelector(state => state.map?.highContrast);
    const dispatch = useDispatch();
    const respondToDarkModeChange = (event) => {
        dispatch(setHighContrast(event.matches));
    };

    const setDarkMode = (isDarkMode) => {
        dispatch(setHighContrast(isDarkMode));
    };

    useEffect(() => {
        // mode flag starts off null, and we set it based on the user's theme choice initially
        // but we don't want to keep resetting it to their system preference
        // i.e. make this overridable, but set to the system preference initially
        if (highContrast === null) {
            dispatch(setHighContrast(query?.matches || false));
        }
    }, []);

    useEffect(() => {
        query.addEventListener('change', respondToDarkModeChange);

        return () => {
            query.removeEventListener('change', respondToDarkModeChange);
        };
    }, []);

    // always return true or false. If null, return false.
    return [highContrast === true, setDarkMode];
};
